import { Box } from "@mui/system";
import ModalTrigger from "../Common/ModalTrigger";

const data = [
    {
        filter: 'Bovine liver',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>891 samples of bovine liver</b> were analysed. In <b>878 samples (98.5%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found. There were no samples reported exceeding the</b> <ModalTrigger text='MRL' />
                <b>or being</b> <ModalTrigger text='non-compliant' />. <b>Multiple residues were reported in 12 samples (1.4%)</b>. In an individual sample, 6 different pesticides (DDT (RD),
                pirimiphos-Methyl (RD), hexachlorobenzene (RD), parathion (RD), dieldrin (RD) and beta- hexachlorocyclohexane (RD)) were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Carrots',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>1,251 samples of carrots</b> were analysed. In <b>720 samples (57.6%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found.</b> In <b>15 samples (1.2%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />, of which <b>10 samples (0.8%) reported as</b> <ModalTrigger text='non-compliant' />
                <b>considering the measurement uncertainty. Multiple residues were reported in 250 samples (20%).</b> In an individual sample, 7 different approved pesticides
                (2-phenylphenol (RD), azoxystrobin (RD), boscalid (RD), cyprodinil (RD), difenoconazole (RD), fludioxonil (RD), pyraclostrobin (RD)) were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Cauliflowers',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>867 samples of cauliflower</b> were analysed. In <b>743 samples (85.7%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. <b>In 9 samples (1.0%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />,
                of which <b>6 samples (0.7%)</b> reported as <ModalTrigger text='non-compliant' /> considering the measurement uncertainty.
                <b>Multiple residues were reported in 15 samples (1.7%)</b>. 3 different pesticides were reported in 4 different samples,
                the ones exceeding the MRL were flonicamid (RD) and pyrimethanil (RD)).
            </p>
        </Box>,
    },
    {
        filter: 'Dried beans',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>719 samples of dried beans</b> were analysed. In <b>519 samples (72.2%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>35 samples (4.9%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />, of which <b>20 samples (2.8%)</b>
                reported as <ModalTrigger text='non-compliant' /> considering the measurement uncertainty.
                <b>Multiple residues were reported in 55 samples (7.6%)</b>. In two individual samples, 5 different pesticides were reported.
                Acetamiprid (RD), Chlorpyrifos (RD) and Cypermethrin (RD) were common finding to both samples.
            </p>
        </Box>,
    },
    {
        filter: 'Kiwi fruits',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>818 samples of kiwi fruits (green, red, yellow) were analysed</b>. In <b>554 samples (67.7%)</b>,
                <ModalTrigger text='pesticide residues' />  <b>were not found</b>. In <b>16 samples (2.0%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />,
                of which <b>10 samples (1.2%)</b> reported as <ModalTrigger text='non-compliant' /> considering the measurement uncertainty.
                <b>Multiple residues were reported in 99 samples (12.1%)</b>. In an individual sample, 5 different pesticides (acetamiprid (RD),
                chlorpyrifos (RD), etofenprox (RD), fludioxonil (RD) and phosmet (RD)) were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Onions',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>1,000 samples of onions were analysed</b>. In <b>906 samples (90.6%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>2 samples (0.2%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />.
                <b>No</b> <ModalTrigger text='non-compliant' /> <b>samples were reported. Multiple residues were reported in 26 samples (2.6%).</b> In an individual sample,
                7 different pesticides (Fluopyram (RD), Fludioxonil (RD), Boscalid (RD), Thiamethoxam (RD), Tebuconazole (RD), Dimethomorph (RD), Cyprodinil (RD))
                were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Oranges',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>1,210 samples of oranges were analysed</b>. In <b>274 samples (22.6%)</b>, <ModalTrigger text='pesticide residues' /> <b>were not found</b>.
                In <b>35 samples (2.9%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />, of which <b>17 samples (1.4%)</b> reported as <ModalTrigger text='non-compliant' />
                considering the measurement uncertainty. <b>Multiple residues were reported in 762 samples (63%).</b>
                In an individual sample, 13 different pesticides (Pyrimethanil (RD), Buprofezin (RD), Iprodione (RD), Fenbutatin Oxide (RD), Propiconazole (RD),
                Chlorpyrifos (RD), Carbendazim (RD), Tau-Fluvalinate (RD), Chlorpyrifos-Methyl (RD), Thiabendazole (RD), Imazalil (RD), Pyriproxyfen (RD), 2,4-D (RD))
                were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Pears',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>1,124 samples of pears were analysed</b>. In <b>275 samples (24.5%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>26 samples (2.3%)</b> the concentration <b>exceed the</b>  <ModalTrigger text='MRL' />,
                of which <b>17 samples (1.5%) reported as</b> <ModalTrigger text='non-compliant' /> considering the measurement uncertainty.
                <b>Multiple residues were reported in 696 samples (61.9%)</b>. In an individual sample, 14 different pesticides (Tebuconazole (RD),
                Iprodione (RD), Fenoxycarb (RD), Fluopyram (RD), Acetamiprid (RD), Thiacloprid (RD), Difenoconazole (RD), Boscalid (RD), Pyrimethanil (RD),
                Pyriproxyfen (RD), Fludioxonil (RD), Carbendazim (RD), Kresoxim-Methyl (RD), Fluxapyroxad (RD)) were reported.
            </p>
        </Box >,
    },
    {
        filter: 'Potatoes',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>1162 samples of potatoes were analysed</b>. In <b>858 samples (73.8%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>9 samples (0.8%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />,
                of which <b>4 samples (0.3%)</b> reported as <ModalTrigger text='non-compliant' /> considering the measurement uncertainty.
                <b>Multiple residues were reported in 49 samples (4.2%)</b>. In an individual sample, 6 different pesticides (Fluopicolide (RD),
                Propamocarb (RD), Dimethomorph (RD), Imidacloprid (RD), Chlorpropham (RD), Boscalid (RD)) were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Poultry fat',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>1,595 samples of poultry fat were analysed</b>. In <b>1,581 samples (99.1%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>1 sample (0.06%) the concentration exceed the</b> <ModalTrigger text='MRL' />
                <b>being</b> <ModalTrigger text='non-compliant' /> <b>too</b>. <b>Multiple residues were reported in 2 samples (0.12%)</b>. In the two samples, <b>2 different pesticides were reported</b>.
                DDT (RD) was common to both samples. The other pesticides reported were hexachlorobenzene (RD) and dieldrin (RD).
            </p>
        </Box>,
    },
    {
        filter: 'Rye',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>638 samples of rye were analysed</b>. In <b>444 samples (69.6%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>7 samples (1.1%) the concentration exceed the</b> <ModalTrigger text='MRL' /> of which <b>3 samples (0.5%) reported
                    as</b> <ModalTrigger text='non-compliant' /> considering the measurement uncertainty. <b>Multiple residues</b> were reported in <b>99 samples (15.5%)</b>.
                In <b>17 individual samples, 4 different pesticides</b> were reported.
            </p>
        </Box>,
    },
    {
        filter: 'Rice',
        body: <Box display='flex' justifyContent='center'>
            <p style={{ maxWidth: '700px' }}>
                <b>802 samples of rice were analysed</b>. In <b>526 samples (65.5%)</b>, <ModalTrigger text='pesticide residues' />
                <b>were not found</b>. In <b>54 samples (6.7%)</b> the concentration <b>exceed the</b> <ModalTrigger text='MRL' />, of which <b>25 samples (3.1%) reported as</b> <ModalTrigger text='non-compliant' />
                considering the measurement uncertainty. <b>Multiple residues were reported in 134 samples (16.7%). In an individual sample,
                    15 different pesticides were reported</b> (Imidacloprid (RD), Lambda-cyhalothrin (RD), Tebuconazole (RD), Tricyclazole (RD), Hexaconazole (RD),
                Bromide Ion (RD), Propiconazole (RD), Chlorpyrifos (RD), Buprofezin (RD), Isoprothiolane (RD), Carbendazim (RD), Thiamethoxam (RD),
                Azoxystrobin (RD), Trifloxystrobin (RD), Triazophos (RD)).
            </p>
        </Box>,
    },
]


const Intro = (props) => {
    const found = data.find(d => d.filter === props.name);
    return (
        <Box sx={{ textAlign: 'center' }}>
            <p style={{ textTransform: 'uppercase' }}>Detailed results</p>
            <h3>{props.name}</h3>
            {found && found.body}
        </Box>
    );
}

export default Intro;